import { supabase } from '../lib/supabase'
import type { Metric } from './metrics'

export interface Period { id: string; reference_month: string; status: 'PREVIEW' | 'FINAL' | 'CLOSED' }

export async function loadPeriods(signal: AbortSignal): Promise<Period[]> {
  const periods: Period[] = []
  for (let offset = 0; ; offset += 500) {
    const { data, error } = await supabase.from('reporting_periods')
      .select('id,reference_month,status').order('reference_month', { ascending: false })
      .range(offset, offset + 499).abortSignal(signal)
    if (error) throw error
    periods.push(...data)
    if (data.length < 500) return periods
  }
}

export async function loadMetrics(periodId: string, signal: AbortSignal): Promise<Metric[]> {
  const batchQuery = () => supabase.from('import_batches').select('id')
    .eq('period_id', periodId).eq('is_current', true).eq('status', 'SUCCEEDED')
    .abortSignal(signal).maybeSingle()
  const batch = await batchQuery()
  if (batch.error) throw batch.error
  if (!batch.data) return []
  const metrics: Metric[] = []
  for (let offset = 0; ; offset += 500) {
    const { data, error } = await supabase.from('indicator_metrics')
      .select('id,attendance_count,tma_total_seconds,tma_sample_count,tme_total_seconds,tme_sample_count,queues!inner(id,display_name,kind,timing_enabled),operators(id,external_name,display_name)')
      .eq('import_batch_id', batch.data.id).order('id').range(offset, offset + 499).abortSignal(signal)
    if (error) throw error
    metrics.push(...data as unknown as Metric[])
    if (data.length < 500) break
  }
  const current = await batchQuery()
  if (current.error) throw current.error
  if (current.data?.id !== batch.data.id) throw new Error('Importação alterada durante a consulta.')
  return metrics
}
